import { Configuration } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { APP_VARIANT_IDENTIFIER } from '@/constants/app';
import {
  API_SERVICE_URL,
  APP_VARIANT_HEADER_NAME
} from '@/features/api/constants/api';
import { errorMiddleware } from '@/features/api/hooks/errorMiddleware';
import { useAuth } from '@/features/authorization/provider/useAuth';
import { useAuthStore } from '@/features/authorization/store/useAuthStore';

export const useApiConfiguration = (): Configuration => {
  const { isAuthenticated } = useAuth();

  return useMemo(
    () =>
      new Configuration({
        middleware: [errorMiddleware],
        basePath: API_SERVICE_URL,
        ...(isAuthenticated
          ? {
              accessToken: () => {
                const accessToken = useAuthStore.getState().token?.accessToken;
                if (!accessToken) {
                  throw new Error('No access token available');
                }
                return `Bearer ${accessToken}`;
              }
            }
          : {}),
        headers: {
          [APP_VARIANT_HEADER_NAME]: APP_VARIANT_IDENTIFIER
        }
      }),
    [isAuthenticated]
  );
};
